module.exports = __webpack_public_path__ + "static/couple-looking-at-a-laptop.ae06658e.webp";